export default "<p>\n  home-user works!\n</p>\n";